export default Object.freeze({
  Administration: 1,
  Process: 2,
  Request: 3,
  Generic: 4,
  PowerBIConnector: 5,
});
